
import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    titleHeader: {
      display: 'flex',
      marginTop: '28px',
    },
  
    contentBody: () => {
      return  {
        width: '100%',
        display: 'flex',
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '28px 0px 56px 0px',
      };
    },

    backButton: () => {
      return  {
        marginTop: '28px !important',
      };
    },

    errorMsg: () => {
      return  {
        marginBottom: '12px !important',
        width: '50%',
        textAlign: 'center',
      };
    },

    powered: () => {
      return  {
         display: 'flex',
         height: '100%',
         marginTop: '24px',
  
         justifyContent: 'space-between',
         alignItems: 'center',
  
         '& img': {
            height: '13px',
            border: 'none',
            outline: 'none',
            marginBottom: '-3px',
         }
      };
    },

});

export default styles;
export const useStyles = makeStyles(styles);
